module.exports = __webpack_public_path__ + "img/collection-weddingRingsStylesElegant.930e95f.webp";